export const COORD_DECIMAL_PRECISION = 6;
